module.exports = __webpack_public_path__ + "../public/img/cores-01.c102c76e.svg";